"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _getUserAgent = require("../_utils/getUserAgent");
var _clsx = _interopRequireDefault(require("clsx"));
var _LinkWrapper = _interopRequireDefault(require("../RelatedContentCard/LinkWrapper"));
var _excluded = ["lines", "readMoreUrl", "readMoreText", "divTag", "lineHeight", "externalUrl"];
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    truncated: function truncated(props) {
      return {
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: props.lines
      };
    },
    truncatedIE: function truncatedIE(props) {
      return {
        maxHeight: 'calc(1em * ' + (typeof props.lineHeight === 'number' ? props.lineHeight : theme.typography.body1.lineHeight) + ' * ' + props.lines + ')',
        lineHeight: props.lineHeight,
        padding: '0 !important',
        display: 'block',
        position: 'relative'
      };
    }
  };
});
var Truncate = function Truncate(_ref) {
  var _ref$lines = _ref.lines,
    lines = _ref$lines === void 0 ? 1 : _ref$lines,
    _ref$readMoreUrl = _ref.readMoreUrl,
    readMoreUrl = _ref$readMoreUrl === void 0 ? '' : _ref$readMoreUrl,
    _ref$readMoreText = _ref.readMoreText,
    readMoreText = _ref$readMoreText === void 0 ? '' : _ref$readMoreText,
    _ref$divTag = _ref.divTag,
    divTag = _ref$divTag === void 0 ? false : _ref$divTag,
    _ref$lineHeight = _ref.lineHeight,
    lineHeight = _ref$lineHeight === void 0 ? 'inherit' : _ref$lineHeight,
    _ref$externalUrl = _ref.externalUrl,
    externalUrl = _ref$externalUrl === void 0 ? false : _ref$externalUrl,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles({
    lines: lines,
    lineHeight: lineHeight
  });
  var Tag = divTag ? 'div' : 'span';
  return __jsx(_react.default.Fragment, null, __jsx(Tag, {
    className: (0, _clsx.default)(classes.truncated, (0, _getUserAgent.isEdge)('<=16') && classes.truncatedIE)
  }, props.children), readMoreUrl && readMoreText && __jsx(_LinkWrapper.default, {
    href: readMoreUrl,
    externalUrl: externalUrl
  }, readMoreText));
};
var _default = Truncate;
exports.default = _default;